// removed by extract-text-webpack-plugin
module.exports = {"buttons":"_1lovc","button":"_3rs_0"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-media-buttons.scss
// module id = 726
// module chunks = 3 4 5 6 7